import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import SmsDetail from '../pages/sms/detail';
import SmsSend from '../pages/sms/send';
import SmsMember from '../pages/sms/member';
import SmsNoMember from '../pages/sms/nomember';
import WriteMessage from '../pages/sms/nomember/WriteMessage';

const SmsRouter: FC = () => {
  return (
    <Switch>
      <Route path="/sms/member" exact component={SmsMember} />
      <Route path="/sms/member/send" exact component={SmsSend} />
      <Route path="/sms/member/:smsSendCode" exact component={SmsDetail} />
      <Route path="/sms/nonmember" exact component={SmsNoMember} />
      <Route path="/sms/nonmember/send" exact component={WriteMessage} />
      <Route path="/sms/nonmember/:smsSendCode" exact component={SmsDetail} />
    </Switch>
  );
};

export default SmsRouter;
